<template>
    <div class="body-code" :class="{'is_fixed':isFixed}" id='boxFixed'>
      <img src="/static/homeIcon/QRcode.png" >
      <div class="title">技术主题推送</div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      isFixed: false,
      offsetTop: 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.initHeight)
    this.$nextTick(() => {
    // 获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置
      this.offsetTop = document.querySelector('#boxFixed').offsetTop
    })
  },
  // 回调中移除监听
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    initHeight() {
    // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // 如果被卷曲的高度大于吸顶元素到顶端位置 的距离
      this.isFixed = scrollTop > this.offsetTop
    }
  }
}
</script>

<style>

</style>
